<p-toast
	[position]="position"
	[key]="key"
	[preventOpenDuplicates]="true"
	data-qa="toast"
>
	<ng-template
		let-message
		pTemplate="message"
	>
		<div
			role="alert"
			aria-live="assertive"
			aria-atomic="true"
			class="p-toast-message-content"
		>
			<div
				class="p-toast-icon-container"
				[attr.aria-label]="message.severity + ' icon'"
			></div>

			<div
				class="p-toast-message-text"
				data-qa="toast-content"
			>
				<h4
					class="p-toast-summary"
					data-qa="toast-summary"
				>
					{{ message.summary }}
				</h4>
				@if (message.detail) {
				<p
					class="p-toast-detail"
					data-qa="toast-detail"
				>
					{{ message.detail }}
				</p>
				} @for (link of message.links; track $index) {
				<button
					type="button"
					class="p-toast-link"
					data-qa="toast-link"
					(click)="onLinkClick(link)"
				>
					{{ link.text }}
				</button>
				}
				<ng-content></ng-content>
			</div>

			@if (actionButtonText) {
			<div class="p-toast-action">
				<button
					data-qa="toast-button"
					type="button"
					pripple=""
					class="btn btn-link"
					(click)="onClick(message)"
				>
					{{ actionButtonText }}
				</button>
			</div>
			}
		</div>
	</ng-template>
</p-toast>
